// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"6f7a1303","787":"4be05764"}[chunkId] + ".chunk.js";
};